export const transitionProps = {
  exit: {
    length: 0.2
  },
  entry: {
    length: 0.3
  }
};
